export const MAX_SUFFIX = 10;
export const BASE_TAGS = [
  "b",
  "i",
  "p",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "sub",
  "sup",
  "u",
  "div",
  "a",
  "ol",
  "ul",
  "li",
  "span",
  "em",
  "br",
  "hr",
  "strong"
];
export const VOID_TAGS = ["br", "hr", "img"];
export const DIRECTIONAL_TAGS = ["p", "h2", "h3", "h5"]; // TODO: Investigate why we have limited tags in DIRECTIONAL_TAGS
export const CLASS_MAP = {
  h2: "",
  h3: "tag heading",
  h5: "tag heading",
  p: "tag content_component",
  b: "tag",
  i: "tag",
  sub: "tag subscript",
  sup: "tag hyperlink",
  em: "tag",
  rfp: "tag",
};
